import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import Panel from '../controls/Panel';
import NavLink from '../controls/NavLink';
import Typography from '@material-ui/core/Typography';

const styles = (theme) => ({
    panel: {
        textAlign: 'center',
    },
    content: {
        marginTop: theme.spacing(6),
        paddingLeft: '25%',
        paddingRight: '25%',
    },
    contentSpacer: {
        ...theme.mixins.toolbar,
        marginTop: theme.spacing(3),
    },
    footer: {
        marginTop: theme.spacing(6),
    },
});

class SubmitMessage extends React.Component {
    state = {
        id: 0,
    };

    componentDidMount() {
        this.setState({
            id: this.props.match.params.id,
        });
    }

    render() {
        return (
            <Grid container justifyContent="center">
                <Grid item xs={12} md={9} lg={6}>
                    <div className={this.props.classes.contentSpacer} />
                    <Panel className={this.props.classes.panel}>
                        <Typography variant="h6">Your form has been submitted!</Typography>
                        <div className={this.props.classes.content}>
                            <Typography variant="subtitle2">
                                You are in admin preview mode so nothing has actually been submitted. However, a user
                                would have been transferred back to the dashboard at this point.
                            </Typography>
                        </div>
                        <div className={this.props.classes.footer}>
                            <NavLink to={`/form/${this.state.id}`}>Return to Form Builder</NavLink>
                        </div>
                    </Panel>
                </Grid>
            </Grid>
        );
    }
}

export default withRouter(withStyles(styles)(SubmitMessage));
